import classNames from "classnames"
import { ValueView } from "web/components"

import { RecordContext } from "web/contexts"

export default function DataRows({ rows, data, isComparison }) {
  const cellClasses = classNames(
    "h-10 truncate border-b border-neutral-9 px-2.5 py-0 text-sm",
    {
      "border-primary-9": isComparison,
    }
  )

  const rowClasses = classNames("odd:bg-white", {
    "bg-primary-10": isComparison,
  })

  return (
    <RecordContext.Provider value={data}>
      {rows.map((row, i) => {
        return (
          <tr key={i} className={rowClasses}>
            <td className={cellClasses}>
              <ValueView
                fieldKey={row.key}
                percentValue={data.values[row.key]?.percent_value}
                fieldPresentation={row.presentation}
                {...data.values[row.key]}
              />
            </td>
          </tr>
        )
      })}
    </RecordContext.Provider>
  )
}
